import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { MovieCard } from './MovieCard';
import type { Collection } from '@/shared/types';
import { getMoviesByIds } from '@/shared/data';

export function MovieRow({
  collection,
  variant = 'landscape',
}: {
  collection: Collection;
  variant?: 'landscape' | 'portrait';
}) {
  const movies = getMoviesByIds(collection.movieIds);
  return (
    <section data-testid="movie-row" data-collection={collection.slug} className="mb-8 pl-4">
      <div className="flex items-center justify-between pr-4 mb-3">
        <h3 className="font-serif italic text-lg text-white">{collection.title}</h3>
        <Link
          to={`/movieflix/collection/${collection.slug}`}
          className="text-[10px] uppercase tracking-widest text-amber-200/70 flex items-center"
        >
          View all <ChevronRight className="w-3 h-3" />
        </Link>
      </div>
      <div className="flex gap-3 overflow-x-auto pb-3 pr-4 scrollbar-hide snap-x">
        {movies.map((m) => (
          <MovieCard key={m.id} movie={m} variant={variant} />
        ))}
      </div>
    </section>
  );
}
